import React from 'react';
import './styles.scss';
import {IonButton, IonButtons, IonFooter, IonImg, IonList, IonText, IonToolbar} from '@ionic/react';
import footerLogo from '../../images/30a-logo.png';
import {useTranslation} from 'react-i18next';
import {Routes} from '../../shared/routes';

const Footer: React.FC = () => {
  const {t} = useTranslation();
  // const {uplinkSpeed,streamWidth} = useSelector(({networkData}: ReduxSelectors) => networkData);
  return (
    <>
      <IonFooter className="app-footer">
        <IonToolbar color={"#1f1f1f"}>
          <IonList>
            <IonImg src={footerLogo}/>
            {/*{uplinkSpeed > 0 && streamWidth > 0 ? */}
            {/*<div style={{display:'flex', flexDirection:'row'}}>*/}
            {/*  <div>Uplink Speed - <span style={{color:'red'}}>{uplinkSpeed.toFixed(2)} Mbps </span></div>*/}
            {/*  <div style={{marginLeft:20}}>Stream Width - <span style={{color:'red'}}>{streamWidth} </span></div>*/}
            {/*</div>: null}*/}
            <IonButtons>
              <IonButton  routerLink={Routes.PrivacyPolicy}
                         routerDirection="back">{t('footer.privacy')}</IonButton>
              <IonButton  routerLink={Routes.TermsAndConditions}
                         routerDirection="back">{t('footer.terms')}</IonButton>
              <IonButton  routerLink={Routes.ChildSafety}
                         routerDirection="back">{t('footer.safety')}</IonButton>
            </IonButtons>
          </IonList>
        <IonText className="copyright font-normal" color="medium" >{t('footer.copyright')}</IonText>
        </IonToolbar>
      </IonFooter>
    </>
  );
};

export default Footer;
